import React, { useState, useEffect } from "react";
import "./CreateQuestionsQB.css";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosAddCircle } from "react-icons/io";
import PublishPreviewQB from "../PublishPreviewQue/PublishPreviewQB";
import DefaultQuestion from "../DefaultQuestion/DefaultQuestion";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

export default function CreateQuestionsQB() {

  //Added this state by Kuldeep
  const { state } = useLocation()
  const [preview, setPreview] = useState();
  const [questionBankData, setQuestionBankData] = useState();
  const [btnDisable, setBtnDisable] = useState(false);
  const [questions, setQuestions] = useState([]);

  const [skillsData, setSkillsData] = useState([])
  const [difficulty_levelData, setDifficulty_levelData] = useState([])
  const [questionType, setQuestionType] = useState([])
  const [countSkills, setCountSkills] = useState([])
  const [countDifficulty, setCountDifficulty] = useState([])
  const [countQsType, setCountQsType] = useState([])
  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("QBIMP"));
    setQuestionBankData(data);
    setQuestions((prev) => [
      ...prev,
      {
        standard_id: state.standard_id ? state.standard_id : null,
        subject_id: state.subject_id ? state.subject_id : null,
        section_id: state.section_id ? state.section_id : null,
        book_id: null,
        chapter_id: null,
        type_id: "633f1d020d529e489aeb74c7",
        domain_id: null,
        skill_id: null,
        difficulty_level: null,
        title: null,
        correct_score: null,
        is_mandatory: false,
        add_to: null,
        add_to_mock: false,
        attachments: [],
        options: [
          {
            key: "A",
            value: null,
          },
          {
            key: "B",
            value: null,
          },
        ],
        correct_answers: [
          {
            option_key: null,
            value: null,
            reason_for_answer: {
              explanation: null,
            },
          },
        ],
      },
    ]);
  }, []);


  useEffect(() => {
    questions.forEach((obj) => {
      if (
        obj.title === null ||
        obj.title.trim() === "" ||
        obj.skill_id === null ||
        obj.domain_id === null ||
        obj.type_id === null ||
        obj.chapter_id === null ||
        obj.correct_score === null ||
        obj.difficulty_level === null ||
        obj.add_to === null
      ) {
        setBtnDisable(true);
      } else {
        setBtnDisable(false);
      }
    });
  }, [questions]);
  const addMoreQuestion = () => {
    setQuestions((prev) => [
      ...prev,
      {
        standard_id: state.standard_id ? state.standard_id : null,
        subject_id: state.subject_id ? state.subject_id : null,
        section_id: state.section_id ? state.section_id : null,
        book_id: null,
        chapter_id: null,
        type_id: "633f1d020d529e489aeb74c7",
        domain_id: null,
        skill_id: null,
        difficulty_level: null,
        title: null,
        correct_score: null,
        is_mandatory: false,
        add_to: null,
        add_to_mock: false,
        attachments: [],
        options: [
          {
            key: "A",
            value: null,
          },
          {
            key: "B",
            value: null,
          },
        ],
        correct_answers: [
          {
            option_key: null,
            value: null,
            reason_for_answer: {
              attachment: null,
              explanation: null,
            },
          },
        ],
      },
    ]);
  };

  const findTotalMarks = () => {
    return questions.reduce((acc, curr) => acc + Number(curr.correct_score), 0);
  };

  useEffect(() => {
    const dataCounter = {
      Skills: {},
      DifficultyLevel: {},
      QuestionType: {}
    }

    questions.map((item, index) => {
      const correctScore = Number(item.correct_score);
      if (item.question_type !== null) {
        if (dataCounter['QuestionType'][item.question_type] === undefined) {
          dataCounter['QuestionType'][item.question_type] = correctScore
        } else {
          setCountDifficulty({})
          dataCounter['QuestionType'][item.question_type] += correctScore
        }
      }
      if (item.question_type !== null) {
        if (dataCounter['Skills'][item.skill_id] === undefined) {
          dataCounter['Skills'][item.skill_id] = correctScore
        } else {
          setCountDifficulty({})
          dataCounter['Skills'][item.skill_id] += correctScore
        }
      }
      if (item.question_type !== null) {
        if (dataCounter['DifficultyLevel'][item.difficulty_level] === undefined) {
          dataCounter['DifficultyLevel'][item.difficulty_level] = correctScore
        } else {
          setCountDifficulty({})
          dataCounter['DifficultyLevel'][item.difficulty_level] += correctScore
        }
      }
      setCountDifficulty({})
    })

    setCountQsType(dataCounter)
    setCountSkills(dataCounter)
    setCountDifficulty(dataCounter)
    // question_type,skill_id,difficulty_level
  }, [questions])


  return (
    <div>
      <div>
        <div className="d-flex gap-2 align-items-center" style={{ position: "relative" }}>
          <IoIosArrowBack
            onClick={() => window.history.back()}
            style={{ cursor: "pointer" }}
          />
          <div
            onClick={() => window.history.back()}
            style={{ cursor: "pointer" }}
          >
            Question bank
          </div>
          <div>/</div>
          <div className="CreateNew_path">Create New</div>
          <div className="needfulinfo d-flex gap-4 align-item-center p-2" style={{ position: "absolute", top: "-70px", left: "280px", flexWrap: "wrap" }}>
            <div className="allmarks">
              <div className="sktext d-flex justify-content-between flex-column"><span>Total Marks: {findTotalMarks()}</span> <span>Total Question: {questions.length}</span></div>
            </div>
            <div className="skills d-flex align-item-center justify-content-center border border-2 rounded-3" style={{ padding: "6px 10px" }}>
              <div className="needfulimg">
                <img src="/images/needfulimg.png" alt="needfulimg" style={{ width: "260px", marginRight: "12px", }}></img>
              </div>
              <div className="textpart">
                <h5 className="needful_heading">Skills</h5>
                {
                  skillsData?.map((curr, index) => {
                    return (
                      <div className="sktext d-flex justify-content-between"> <span>{curr.name + " : "}</span> <span className="ms-4">{countSkills.Skills[curr.id] === undefined ? 0 : countSkills.Skills[curr.id]}</span></div>
                    )
                  })
                }
              </div>
            </div>
            <div className="difficulty_level border border-2 rounded-3" style={{ padding: "6px 15px" }}>
              <h5 className="needful_heading">Difficulty Level</h5>
              {
                difficulty_levelData?.map((curr, index) => {
                  return (
                    <div className="diftext d-flex justify-content-between"><span>{curr.name + " : "}</span> <span>{countDifficulty.DifficultyLevel[curr.id] === undefined ? 0 : countDifficulty.DifficultyLevel[curr.id]}</span></div>
                  )
                })
              }
            </div>
            <div className="ques_type border border-2 rounded-3" style={{ padding: "6px 10px" }}>
              <h5 className="needful_heading">Question Type</h5>
              {
                questionType?.map((curr, index) => {
                  return (
                    <div className="qstext d-flex justify-content-between"><span>{curr.name + " : "}</span> <span className="ms-3">0</span></div>
                  )
                })
              }
            </div>
          </div>
        </div>
        <div className="ml-5 mt-5 total_container_QB">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <div className="globalWarming">{questionBankData?.name}</div>
              <div className="d-flex gap-2 flex-wrap">
                <div>
                  {questionBankData?.questionBankDetails?.subject_id?.name}
                </div>
                <div>|</div>
                <div>Lecture Content</div>
              </div>
            </div>
          </div>
          <div className="qustionBk">
            {questions.length > 0 &&
              questions.map((question, index) => (
                <DefaultQuestion
                  key={index}
                  questionNo={index}
                  question={question}
                  setQuestions={setQuestions}
                  questionBankDetails={questionBankData?.questionBankDetails}
                  setSkillsData={setSkillsData}
                  setDifficulty_levelData={setDifficulty_levelData}
                  setQuestionType={setQuestionType}
                />
              ))}
          </div>
          <div className="d-flex justify-content-center">
            <button
              className="addQuestionBtn_Qb add_question_button"
              onClick={() => {
                addMoreQuestion();
              }}
            >
              <IoIosAddCircle /> Add question
            </button>
          </div>
          <div className="d-flex justify-content-end gap-2">
            <button
              onClick={(e) => {
                let nullAddTo = questions.filter((val) => val.add_to == null);
                if (nullAddTo.length > 0) {
                  toast.error("Please select at least checkbox for Homework or Assessment")
                  return false;
                }
                setPreview(true);
              }}
              className={btnDisable ? "NextBtn_cmDACTV" : "NextBtn_cm"}
              disabled={btnDisable}
            >
              Next
            </button>
          </div>
        </div>
      </div>
      {preview && (
        <PublishPreviewQB
          setPreview={setPreview}
          displayQuestions={questions}
          details={questionBankData}
          type={"create"}
        />
      )}
    </div>
  );
}
